module.exports = __webpack_public_path__ + "img/more_white.32216639.svg";